export default function( num: number ): string {
	if ( typeof num === "number" && !Number.isNaN( num ) ) {
		return `$${num.toFixed( 2 ).replace( /(\d)(?=(\d{3})+\.)/g, "$1," )}`.replace( "$-", "-$" );
	}

	return `${num}`;
}
